// Thin wrapper around window.gtag to fire GA4 e-commerce + page_view events
// No-ops if gtag isn't loaded yet (safe to call from anywhere).

const GA_ID = "G-VQTLGS7CL8";

function gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackPageView(path) {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_ID,
  });
}

function toGaItem(item) {
  return {
    item_id: item.product_id || item.id,
    item_name: item.name,
    item_category: item.category,
    item_variant: [item.size, item.color].filter(Boolean).join(" / "),
    price: Number(item.price) || 0,
    quantity: item.quantity || 1,
  };
}

export function trackViewItem(product) {
  if (!product) return;
  gtag("event", "view_item", {
    currency: "INR",
    value: Number(product.price) || 0,
    items: [toGaItem(product)],
  });
}

export function trackAddToCart(product, size, quantity = 1, color = null) {
  if (!product) return;
  gtag("event", "add_to_cart", {
    currency: "INR",
    value: (Number(product.price) || 0) * quantity,
    items: [toGaItem({ ...product, product_id: product.id, size, color, quantity })],
  });
}

export function trackBeginCheckout(items, total) {
  gtag("event", "begin_checkout", {
    currency: "INR",
    value: Number(total) || 0,
    items: (items || []).map(toGaItem),
  });
}

export function trackPurchase({ transaction_id, value, items }) {
  gtag("event", "purchase", {
    transaction_id,
    currency: "INR",
    value: Number(value) || 0,
    items: (items || []).map(toGaItem),
  });
}
